// Port of api/fuel/app/classes/filter/search/games/filters/query/collection/inventory/location/text.php
import Util from 'offline/util'

export default {
	name: 'collection.inventory.location.text',
	priority: 86,
	require: function(config, filter) {
		return filter.inventory && filter.inventory.location && filter.inventory.location.text && filter.inventory.location.text !== '' && config.can && config.can['view.inventory.location']
	},
	run: function(config, filter, data, query) {
		var text = Util.sortname(filter.inventory.location.text.toLowerCase())
		var keywords = text.split(' ')
		for (var i = 0; i < keywords.length; i++) {
			var keyword = keywords[i]
			if (!keyword) continue
			var prefix = keyword.length > 1 ? '%' : ''
			query.where('c.collection_private_location', 'like', prefix + keyword + '%')
		}
	}
}
